import history from '../../util/history'
import { appActions } from '../AppActions'
import StripeApiKeyRepository from '../../infra/StripeApiKeyRepository'

const onRequestDelete = async stripeApiKeyId => {
  const response = await StripeApiKeyRepository.requestDelete(stripeApiKeyId).catch(e => e)
  if (response instanceof Error) {
    appActions.showAlert(response, '削除に失敗しました')
    return false
  }

  history.goBack()
  appActions.snackbar('削除しました', 'success', true)
  return true
}

export default onRequestDelete
